import i18n from '../i18n';

export default class ReasonType {
  public static readonly NONE = new ReasonType('0', '-');
  public static readonly NONSKU = new ReasonType('01', 'SKU登録無し'); // 1
  public static readonly NONASIN = new ReasonType('02', 'ASIN無効'); // 2
  public static readonly NONLAS = new ReasonType('04', 'LAS登録無し'); // 3
  public static readonly RETURN = new ReasonType('05', '返品依頼');
  public static readonly DELETE = new ReasonType('06', '廃棄依頼');
  public static readonly NOTMATCH = new ReasonType('07', '数量不一致');
  public static readonly CHANGE = new ReasonType('08', '修正・削除依頼');
  public static readonly NONSIZE = new ReasonType('09', 'サイズ無し');
  public static readonly NOTEXPORT = new ReasonType('10', '輸出不可');
  public static readonly OTHER = new ReasonType('12', 'その他');
  public static readonly REQOUT = new ReasonType('13', '出品許可要');
  public static readonly NOTREQINFO = new ReasonType('14', '有効な出品情報無し');
  public static readonly NOTSET = new ReasonType('16', 'セット登録なし');
  public static readonly NOTJAN = new ReasonType('17', 'JANなし商品');
  public static readonly NOTEXISTJAN = new ReasonType('18', '商品にJANがありません');
  public static readonly NOTSCANJAN = new ReasonType('19', '商品JANがスキャン出来ない状態で届きました');
  public static readonly SPLIT1 = new ReasonType('20', '行き先わかれ（商品登録時のバーコードタイプ選択ミス）※再登録後、古いASINは削除してください。');
  public static readonly SPLIT2 = new ReasonType('21', '行き先わかれ（納品先が分かれます納品プランを作成して確認してください）');
  public static readonly INCORRECTNUM = new ReasonType('22', '数量違い');
  public static readonly NGFBA = new ReasonType('23', 'FBA納品不可になりました。一度セラセンで納品プランを作成してご確認下さい');
  public static readonly NOTSHIPEXSPECIAL = new ReasonType('25', '特殊便以外での発送不可');
  public static readonly VARIATIONITEM = new ReasonType('26', 'バリエーション商品の為');
  public static readonly REMOVE = new ReasonType('28', '修正依頼'); // 08の削除・変更依頼を分離
  public static readonly CHANGE2 = new ReasonType('29', '削除依頼'); // 08の削除・変更依頼を分離
  public static readonly SHIPONLYTOKUSYU = new ReasonType('91', '特殊便でのみ発送可能'); // 発送処理のstatus欄に表示するのみの用途
  public static readonly NONSKUKANRI = new ReasonType('101', 'SKU登録無し(管理品)'); // AMAZONにSKU登録済だが管理品登録されているケース
  public static readonly NONASINKANRI = new ReasonType('102', 'ASIN無効'); // AMAZONにASINは存在しているが管理品登録されているケース

  // 問題自由のtextをリターンする（管理品画面想定）
  public static getStatusStrWithOther(value: string, other: string): string {
    for (const v of this.valuesAll()) {
      if (v.value === value) {
        if(v.value === ReasonType.OTHER.value){
          return v.text + '(' + other + ')';
        }
        return v.text;
      }
    }
    return ReasonType.NONE.text;
  }

  public static valueOf(value: string): ReasonType {
    for (const v of this.valuesAll()) {
      if (v.value === value) {
        return v;
      }
    }
    return ReasonType.NONE;
  }

  public static getStatusStr(status: string): any {
    let statusList = [];
    for (const v of status.split(',')) {
      let _stat = this.valueOf(v);
      if(_stat !== ReasonType.NONE){
        statusList.push(_stat.text);
      }
    }
    return statusList;
  }

  // 全データ
  public static values(): any {
    return [
      { value: this.NONSKU.value, text: i18n.t(this.NONSKU.text) },
      { value: this.NONASIN.value, text: i18n.t(this.NONASIN.text) },
      { value: this.NONLAS.value, text: i18n.t(this.NONLAS.text) },
      { value: this.NOTMATCH.value, text: i18n.t(this.NOTMATCH.text) },
      { value: this.NONSIZE.value, text: i18n.t(this.NONSIZE.text) },
      { value: this.NOTEXPORT.value, text: i18n.t(this.NOTEXPORT.text) },
      { value: this.REQOUT.value, text: i18n.t(this.REQOUT.text) },
      { value: this.RETURN.value, text: i18n.t(this.RETURN.text) },
      { value: this.NOTREQINFO.value, text: i18n.t(this.NOTREQINFO.text) },
      { value: this.NOTSET.value, text: i18n.t(this.NOTSET.text) },
      { value: this.NOTJAN.value, text: i18n.t(this.NOTJAN.text) },
      { value: this.NOTEXISTJAN.value, text: i18n.t(this.NOTEXISTJAN.text) },
      { value: this.NOTSCANJAN.value, text: i18n.t(this.NOTSCANJAN.text) },
      { value: this.SPLIT1.value, text: i18n.t(this.SPLIT1.text) },
      { value: this.SPLIT2.value, text: i18n.t(this.SPLIT2.text) },
      { value: this.INCORRECTNUM.value, text: i18n.t(this.INCORRECTNUM.text) },
      { value: this.NGFBA.value, text: i18n.t(this.NGFBA.text) },
      { value: this.NOTSHIPEXSPECIAL.value, text: i18n.t(this.NOTSHIPEXSPECIAL.text) },
      { value: this.VARIATIONITEM.value, text: i18n.t(this.VARIATIONITEM.text) },
      { value: this.OTHER.value, text: i18n.t(this.OTHER.text) },
    ];
  }
    // 全データ
  public static valuesAll(): any {
      return [
        { value: this.NONSKU.value, text: i18n.t(this.NONSKU.text) },
        { value: this.NONASIN.value, text: i18n.t(this.NONASIN.text) },
        { value: this.NONLAS.value, text: i18n.t(this.NONLAS.text) },
        { value: this.RETURN.value, text: i18n.t(this.RETURN.text) },
        { value: this.DELETE.value, text: i18n.t(this.DELETE.text) },
        { value: this.NOTMATCH.value, text: i18n.t(this.NOTMATCH.text) },
        { value: this.CHANGE.value, text: i18n.t(this.CHANGE.text) },
        { value: this.NONSIZE.value, text: i18n.t(this.NONSIZE.text) },
        { value: this.NOTEXPORT.value, text: i18n.t(this.NOTEXPORT.text) },
        { value: this.REQOUT.value, text: i18n.t(this.REQOUT.text) },
        { value: this.NOTREQINFO.value, text: i18n.t(this.NOTREQINFO.text) },
        { value: this.NOTSET.value, text: i18n.t(this.NOTSET.text) },
        { value: this.NOTJAN.value, text: i18n.t(this.NOTJAN.text) },
        { value: this.NOTEXISTJAN.value, text: i18n.t(this.NOTEXISTJAN.text) },
        { value: this.NOTSCANJAN.value, text: i18n.t(this.NOTSCANJAN.text) },
        { value: this.SPLIT1.value, text: i18n.t(this.SPLIT1.text) },
        { value: this.SPLIT2.value, text: i18n.t(this.SPLIT2.text) },
        { value: this.INCORRECTNUM.value, text: i18n.t(this.INCORRECTNUM.text) },
        { value: this.NGFBA.value, text: i18n.t(this.NGFBA.text) },
        { value: this.NOTSHIPEXSPECIAL.value, text: i18n.t(this.NOTSHIPEXSPECIAL.text) },
        { value: this.VARIATIONITEM.value, text: i18n.t(this.VARIATIONITEM.text) },
        { value: this.OTHER.value, text: i18n.t(this.OTHER.text) },
        { value: this.SHIPONLYTOKUSYU.value, text: i18n.t(this.SHIPONLYTOKUSYU.text) },
        { value: this.REMOVE.value, text: i18n.t(this.REMOVE.text) },
        { value: this.CHANGE2.value, text: i18n.t(this.CHANGE2.text) },
        { value: this.NONSKUKANRI.value, text: i18n.t(this.NONSKUKANRI.text) },
        { value: this.NONASINKANRI.value, text: i18n.t(this.NONASINKANRI.text) },
      ];
    }

  // 発送画面の管理ボタン
  public static values1(): any {
    return [
      { value: this.NONE.value, text: i18n.t(this.NONE.text) },
      { value: this.REQOUT.value, text: i18n.t(this.REQOUT.text) },
      { value: this.NOTREQINFO.value, text: i18n.t(this.NOTREQINFO.text) },
      { value: this.OTHER.value, text: i18n.t(this.OTHER.text) },
    ];
  }

  // 入庫画面の右上のボタン
  public static values2(): any {
    return [
      { value: this.NONE.value, text: i18n.t(this.NONE.text) },
      { value: this.NONSKU.value, text: i18n.t(this.NONSKU.text) },
      { value: this.NONASIN.value, text: i18n.t(this.NONASIN.text) },
      { value: this.NONLAS.value, text: i18n.t(this.NONLAS.text) },
      { value: this.NOTEXPORT.value, text: i18n.t(this.NOTEXPORT.text) },
      { value: this.NOTEXISTJAN.value, text: i18n.t(this.NOTEXISTJAN.text) },
      { value: this.NOTSCANJAN.value, text: i18n.t(this.NOTSCANJAN.text) },
      { value: this.SPLIT1.value, text: i18n.t(this.SPLIT1.text) },
      { value: this.SPLIT2.value, text: i18n.t(this.SPLIT2.text) },
      { value: this.INCORRECTNUM.value, text: i18n.t(this.INCORRECTNUM.text) },
      { value: this.NGFBA.value, text: i18n.t(this.NGFBA.text) },
      { value: this.NOTSHIPEXSPECIAL.value, text: i18n.t(this.NOTSHIPEXSPECIAL.text) },
      { value: this.VARIATIONITEM.value, text: i18n.t(this.VARIATIONITEM.text) },
      { value: this.OTHER.value, text: i18n.t(this.OTHER.text) },
    ];
  }
  // 入庫画面の表中のボタン
  public static values3(): any {
    return [
      { value: this.NOTEXPORT.value, text: i18n.t(this.NOTEXPORT.text) },
      { value: this.OTHER.value, text: i18n.t(this.OTHER.text) },
    ];
  }

  private constructor(public readonly value: string, public readonly text: string) {}
  public getValue(): string { return this.value; }
  public getText(): string { return this.text; }
  public equals(other: ReasonType): boolean { return (this.text === other.text) ? true : false; }
  public toString(): string { return `${this.text}(${this.text})`; }
}
